'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _price = require('@hixme-ui/price');

var _price2 = _interopRequireDefault(_price);

var _getLabel = require('./getLabel');

var _getLabel2 = _interopRequireDefault(_getLabel);

var _getPrice = require('./getPrice');

var _getPrice2 = _interopRequireDefault(_getPrice);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BenefitPrice = function BenefitPrice(_ref) {
  var noLabel = _ref.noLabel,
      payCycle = _ref.payCycle,
      value = _ref.value,
      restProps = (0, _objectWithoutProperties3.default)(_ref, ['noLabel', 'payCycle', 'value']);
  return _react2.default.createElement(_price2.default, (0, _extends3.default)({
    value: (0, _getPrice2.default)(value, payCycle),
    label: (0, _getLabel2.default)(payCycle)
  }, restProps));
};

BenefitPrice.displayName = 'hui:BenefitPrice';
BenefitPrice.huiName = 'BenefitPrice';

BenefitPrice.propTypes = {
  value: _propTypes2.default.number.isRequired,
  noLabel: _propTypes2.default.bool,
  payCycle: _propTypes2.default.number
};

BenefitPrice.defaultProps = {
  noLabel: false,
  payCycle: 12
};

exports.default = BenefitPrice;
//# sourceMappingURL=BenefitPrice.js.map


//////////////////
// WEBPACK FOOTER
// ../benefit-price/lib/BenefitPrice.js
// module id = 666
// module chunks = 0